import { ErrorBoundary } from '@monorepo/shared/componentsV2/ErrorBoundary';
import { RoutesWith404 } from '@monorepo/shared/componentsV2/RoutesWith404';
import React from 'react';
import { Route } from 'react-router-dom';
import { FolderDocumentsPage } from './components/FolderDocumentsPage/FolderDocumentsPage';
import { FoldersPage } from './components/FoldersPage/FoldersPage';

export function DocumentsDataSetupRouter() {
  return (
    <RoutesWith404>
      <Route
        index
        element={
          <ErrorBoundary>
            <FoldersPage />
          </ErrorBoundary>
        }
      />
      <Route
        path=":folderId"
        element={
          <ErrorBoundary>
            <FolderDocumentsPage />
          </ErrorBoundary>
        }
      />
    </RoutesWith404>
  );
}
